import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Business Details"),
  /*#__PURE__*/_createElementVNode("div", { class: "muted" }, "Please add your business information.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessDetails = _resolveComponent("BusinessDetails", true)!
  const _component_BusinessAddressForm = _resolveComponent("BusinessAddressForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BusinessDetails, {
      values: _ctx.values,
      containerClass: "d-inline-flex gap-3"
    }, null, 8, ["values"]),
    _createVNode(_component_BusinessAddressForm, {
      values: _ctx.values,
      country: _ctx.values.business_country,
      state: _ctx.values.business_state,
      prefix: `business`,
      colClass: "d-inline-flex gap-3",
      onCountryChange: _ctx.handleCountryChange,
      onCountryBlur: _ctx.handleCountryBlur,
      onStateChange: _ctx.handleStateChange,
      onStateBlur: _ctx.handleStateBlur
    }, null, 8, ["values", "country", "state", "onCountryChange", "onCountryBlur", "onStateChange", "onStateBlur"])
  ]))
}